export type LinkedStockSourceKind = 'sku' | 'master' | 'bundle'

/** แปลง quantity จาก API (decimal อาจเป็น string) */
export const normalizeLinkedQuantity = (value: unknown): number => {
  const n = Number(value)
  return Number.isFinite(n) && n > 0 ? n : 1
}

export type ProductLinkedStockListRow = {
  id: string
  sku_id: string | null
  product_id: string | null
  factory_id: string | null
  ref_type: 'stock' | 'recipe'
  ref_id: string
  sequence: number | null
  is_active: boolean
  quantity: number
  source_kind: LinkedStockSourceKind
  ref_label: string
  ref_stock_type_label?: string | null
  /** id รูปใน master_image — ประกอบ URL เองด้วย backendUrl (ทนต่อ URL_API ต่าง env) */
  ref_image_id?: string | null
  ref_image_url?: string | null
  ref_balance?: number | null
  ref_description?: string | null
  ref_stock_sku_id?: string | null
}

export type LinkedStockUiMode = 'basic' | 'advanced'

export type ListProductLinkedStockInput = {
  sku_id?: string
  product_id?: string
}

export type ListProductLinkedStockResult = {
  data: ProductLinkedStockListRow[]
}

export type SyncLinkedStockItemInput = {
  ref_id: string
  ref_type: 'stock' | 'recipe'
  sequence?: number
  is_active?: boolean
  quantity?: number
}

export type SyncProductLinkedStockInput = {
  sku_id: string
  product_id?: string
  items?: SyncLinkedStockItemInput[]
}

export type SyncProductLinkedStockResult = {
  data: ProductLinkedStockListRow[]
}

/** แถวในตารางคลัง modal SKU (ยังไม่ส่งบันทึก) */
export type SkuLinkedStockDraftRow = {
  key: string
  /** มีค่า = มี product_linked_stock ในฐานข้อมูลแล้ว */
  linked_stock_id?: string
  source_kind: LinkedStockSourceKind
  ref_id: string
  ref_type: 'product_stock' | 'product_recipe'
  ref_label: string
  ref_stock_type_label?: string | null
  /** id รูปใน master_image — ประกอบ URL เองด้วย backendUrl */
  ref_image_id?: string | null
  ref_image_url?: string | null
  ref_balance?: number | null
  ref_description?: string | null
  ref_stock_sku_id?: string | null
  /** ปริมาณที่ใช้ต่อ 1 หน่วย SKU */
  quantity: number
}
